"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateCustomSideNavThemeResponse () {
        return CreateCustomSideNavThemeResponse;
    },
    get DeleteCustomSideNavThemeResponse () {
        return DeleteCustomSideNavThemeResponse;
    },
    get ListSideNavThemesResponse () {
        return ListSideNavThemesResponse;
    },
    get SelectSideNavThemeResponse () {
        return SelectSideNavThemeResponse;
    },
    get SideNavThemeSchema () {
        return SideNavThemeSchema;
    },
    get UpdateCustomSideNavThemeResponse () {
        return UpdateCustomSideNavThemeResponse;
    }
});
const _zod = require("zod");
const SideNavThemeSchema = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    backgroundColor: _zod.z.string(),
    foregroundColor: _zod.z.string(),
    isDefault: _zod.z.boolean()
});
const ListSideNavThemesResponse = _zod.z.object({
    themes: _zod.z.array(SideNavThemeSchema),
    selectedThemeId: _zod.z.string(),
    // Loose number so older clients don't fail Zod parse if the cap is bumped.
    maxCustomThemes: _zod.z.number().int().positive()
});
const CreateCustomSideNavThemeResponse = _zod.z.object({
    theme: SideNavThemeSchema
});
const UpdateCustomSideNavThemeResponse = _zod.z.object({
    theme: SideNavThemeSchema
});
const DeleteCustomSideNavThemeResponse = _zod.z.object({
    deletedThemeId: _zod.z.string(),
    selectedThemeId: _zod.z.string()
});
const SelectSideNavThemeResponse = _zod.z.object({
    selectedThemeId: _zod.z.string()
});
